import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow" }
const _hoisted_2 = { class: "d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search" }
const _hoisted_3 = {
  class: "navbar-nav ml-auto",
  style: {"z-index":"99"}
}
const _hoisted_4 = { class: "nav-item dropdown no-arrow d-sm-none" }
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "searchDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search fa-fw" })
], -1)
const _hoisted_6 = {
  class: "dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in",
  "aria-labelledby": "searchDropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchClient = _resolveComponent("SearchClient")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SearchClient)
    ]),
    _createVNode("ul", _hoisted_3, [
      _createVNode("li", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_SearchClient)
        ])
      ])
    ])
  ]))
}